import { useAuditApi } from "./common/auditApi";

export function usePackageTypeAuditApi() {
  return useAuditApi({
    url: 'packageType',
    translateTitle: (t) => t.audit.actions.fetchPackageType.title,
    translateError: (t) => t.audit.actions.fetchPackageType.error
  });
}
